"use client";

import { FC } from "react";

import RentalCarDatesRangeInput from "./RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "./RentalCarTimesRangeInput";

import { useData } from "data/data-provider";
import LocationInput from "../LocationInput";
import DropOffLocationInput from "../DropOffLocationInput";

export interface RentalCarSearchFormProps {}

const RentalCarSearchForm: FC<RentalCarSearchFormProps> = () => {
  const {
    setPickupLocation,
    setDropoffLocation,
    setSearchedPickupLocation,
    setSearchedDropoffLocation,
    pickupLocation,
    setDropoffLocationType,
    setSameDropoffLocation,
    dropoffLocationType,
  } = useData();

  const renderRadioBtn = () => {
    return (
      <div className=" [ nc-hero-field-padding ] flex items-center flex-wrap flex-row border-b border-secondary-100">
        <div
          className={`py-1.5 px-4 flex items-center rounded-md font-medium text-xs cursor-pointer mr-2 sm:mr-3 ${
            dropoffLocationType === true
              ? "bg-primary-100  border-primary-200 text-button-color shadow-black/10 shadow-lg"
              : " text-text-color"
          }`}
          onClick={(e) => {
            setDropoffLocationType(true);
            setDropoffLocation(pickupLocation);
            setSearchedDropoffLocation(pickupLocation?.name ?? "");
            setSameDropoffLocation(true);
            setPickupLocation(null);
            setDropoffLocation(null);
            setSearchedPickupLocation("");
            setSearchedDropoffLocation("");
          }}
        >
          Same drop off
        </div>
        <div
          className={`py-1.5 px-4 flex items-center rounded-md font-medium text-xs cursor-pointer mr-2 sm:mr-3 ${
            dropoffLocationType === false
              ? "bg-primary-100  border-primary-200 text-button-color shadow-black/10 shadow-lg"
              : " text-text-color"
          }`}
          onClick={() => {
            setDropoffLocationType(false);
            setSameDropoffLocation(false);
            // Reset values
            setPickupLocation(null);
            setDropoffLocation(null);
            setSearchedDropoffLocation("");
            setSearchedPickupLocation("");
          }}
        >
          Different drop off
        </div>
      </div>
    );
  };

  const isDdropOffdifferent = dropoffLocationType === false;

  return (
    <form className="w-full relative mt-8 rounded-md shadow-xl bg-secondary-50/80 pb-5 backdrop-blur-sm">
      <div className="flex flex-start ml-12"></div>
      {renderRadioBtn()}
      <div className={`relative flex flex-row `}>
        <LocationInput
          placeHolder="Pick up Location"
          desc="Where are you going?"
          className="flex-1"
          sameDropOffLocation={dropoffLocationType === false}
        />
        {isDdropOffdifferent && (
          <>
            <div className="self-center border-r border-secondary-100 h-8"></div>
            <DropOffLocationInput
              placeHolder="Drop off Location"
              desc="Where are you going?"
              className="flex-1"
              divHideVerticalLineClass="-inset-x-0.5"
            />
          </>
        )}
        <div className="self-center border-r border-secondary-100 h-8"></div>
        <RentalCarDatesRangeInput className="flex-1" />
        <div className="self-center border-r border-secondary-100 h-8"></div>
        <RentalCarTimesRangeInput
          dropOffLocationType={dropoffLocationType}
          className="flex-2"
          design="designA"
        />
      </div>
    </form>
  );
};

export default RentalCarSearchForm;
